export var NetworkNodeType;
(function (NetworkNodeType) {
    NetworkNodeType["NODEJS"] = "nodejs";
    NetworkNodeType["BROWSER"] = "browser";
})(NetworkNodeType || (NetworkNodeType = {}));
// a subset of environment ids which are available in @streamr/config
// - do not include legacy configs, which no longer work, e.g. "dev0"
// - and no need to include configs, which users won't use in practice
// - note that there is no special handling for empty arrays in the applyConfig and therefore
//   empty arrays will be applied as-is: we may want to remove "enthereum.rpcEndpoints" key
//   from @streamr/config as the intention is to use system-defaults (e.g. Metamask defaults)
//   in Ethereum network
export const ENVIRONMENT_IDS = ['polygon', 'polygonAmoy', 'peaq', 'iotex', 'dev2'];
export const DEFAULT_ENVIRONMENT_ID = 'polygon';
/**
 * @deprecated use {@link STREAMR_STORAGE_NODE_ADDRESS} instead
 */
export const STREAMR_STORAGE_NODE_GERMANY = '0x31546eEA76F2B2b3C5cC06B1c93601dc35c9D916';
export const STREAMR_STORAGE_NODE_ADDRESS = '0x9dc08ff97f5c156181ec6a0b13fc3946454e529a';
export const ConfigInjectionToken = Symbol('Config');
